import React, { Component, PropTypes } from "react";
import { withRouter } from "react-router/es";
import Header from "components/Header";
import Footer from "components/Footer";
import { routeCodes, subRouteCodes } from "constants/routes";
import { connect } from "react-redux";
import { getCurrentUserBrand } from "selectors/user-brands";
import { deriveRoleInfo } from "selectors/user";
import { getDesignItemTypes } from "selectors/type-items";
import MFACenter from 'containers/MFACentre';

//User selector modal
import UserSelectorModal from "containers/UserSelector";

const USER_ROUTES = [
  {
    path: `${routeCodes.MANAGE_ACCOUNT}${subRouteCodes.MANAGE_ACCOUNT.BRAND}`,
    name: "My Brand",
  },
  {
    path: `${routeCodes.MANAGE_ACCOUNT}${subRouteCodes.MANAGE_ACCOUNT.LOCATION}`,
    name: "My Location",
  },
  {
    path: `${routeCodes.MANAGE_ACCOUNT}${subRouteCodes.MANAGE_ACCOUNT.USER_PROFILE}`,
    name: "User Profile",
  },
  {
    path: `${routeCodes.MANAGE_ACCOUNT}${subRouteCodes.MANAGE_ACCOUNT.ASSET_TRANSFER}`,
    name: "Asset Transfer",
  },
];

const ADMIN_MAIN_ROUTES = [];

const ADMIN_USER_ROUTES = [];

@connect((state) => ({
  auth: state.session,
  workflows: state.workflows.get("data"),
  user: state.user.get("data"),
  currentBrand: getCurrentUserBrand(state),
  roleInfo: deriveRoleInfo(state),
  currentPage: state.selectiveTransfer.get("currentPage"),
  notifications: state.notifications,
  syscoProducts: state.syscoProducts.get("data"),
  syscoProductsLoading: state.syscoProducts.get("loading"),
  typeItems: getDesignItemTypes(state),
  recentDesigns: state.recentDesigns.get("data"),
  designs: state.designs.get("data"),
  design: state.design.get("data"),
  userData: state.user.get("data"),
}))
class App extends Component {
  static propTypes = {
    children: PropTypes.object,
    router: PropTypes.object,
    workflows: PropTypes.object,
    auth: PropTypes.object,
    user: PropTypes.object,
    currentBrand: PropTypes.object,
    roleInfo: PropTypes.shape({
      changeAccAllowed: PropTypes.bool,
    }),
    currentPage: PropTypes.number,
    notifications: PropTypes.object,
    syscoProducts: PropTypes.object,
    syscoProductsLoading: PropTypes.bool,
    typeItems: PropTypes.object,
    recentDesigns: PropTypes.object,
    dispatch: PropTypes.func,
    design: PropTypes.object,
    designs: PropTypes.object,
    userData: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      isUserModalOpen: false,
    };
  }

  /**
   * Show/Hide modal upon the given value
   * If the visibility is undefined,
   * it will switch the previous state value
   * @param {Boolean} visibility should the modal be visible
   */
  setChangeAccVisibility = (visibility) => {
    this.setState(({ isUserModalOpen: wasModalOpen }) => ({
      isUserModalOpen: visibility === undefined ? !wasModalOpen : visibility,
    }));
  };

  render() {
    const {
      children,
      router,
      auth,
      workflows,
      user,
      currentBrand,
      roleInfo,
      currentPage,
      notifications,
      syscoProducts,
      syscoProductsLoading,
      typeItems,
      recentDesigns,
      dispatch,
      design,
      designs,
      userData,
    } = this.props;
    const { location } = router;

    const navigateToDashboard = () => router.push(routeCodes.DASHBOARD);

    if (
      location.pathname.includes(routeCodes.DESIGNER) ||
      location.pathname.includes(routeCodes.LOGIN)
    ) {
      return <div className="application">{children}</div>;
    }

    if (location.pathname.includes(routeCodes.ADMIN)) {
      return (
        <div className="application">
          <Header
            mainRoutes={ADMIN_MAIN_ROUTES}
            userRoutes={ADMIN_USER_ROUTES}
            onNavigate={navigateToDashboard}
            auth={auth}
            workflows={workflows}
            user={user}
            currentBrand={currentBrand}
            roleInfo={roleInfo}
            currentPage={currentPage}
            notifications={notifications}
            syscoProducts={syscoProducts}
            syscoProductsLoading={syscoProductsLoading}
            typeItems={typeItems}
            recentDesigns={recentDesigns}
            dispatch={dispatch}
            design={design}
            designs={designs}
            userData={userData}
          />
          {children}
          <Footer />
        </div>
      );
    }

    if (
      location.pathname.includes(routeCodes.DESIGNER) ||
      location.pathname.includes(routeCodes.LOGIN)
    ) {
      return <div className="application">{children}</div>;
    }
    if (location.pathname.includes(routeCodes.ADMIN)) {
      return (
        <div className="application">
          <Header
            mainRoutes={ADMIN_MAIN_ROUTES}
            userRoutes={ADMIN_USER_ROUTES}
            onNavigate={navigateToDashboard}
            auth={auth}
            workflows={workflows}
            user={user}
            currentBrand={currentBrand}
            roleInfo={roleInfo}
            currentPage={currentPage}
            notifications={notifications}
            syscoProducts={syscoProducts}
            syscoProductsLoading={syscoProductsLoading}
            typeItems={typeItems}
            recentDesigns={recentDesigns}
            dispatch={dispatch}
            design={design}
            designs={designs}
            userData={userData}
          />
          {children}
          <Footer />
        </div>
      );
    }
    return (
      <div className="application">
        <Header
          userRoutes={USER_ROUTES}
          onNavigate={navigateToDashboard}
          setChangeAccVisibility={this.setChangeAccVisibility}
          auth={auth}
          workflows={workflows}
          user={user}
          currentBrand={currentBrand}
          roleInfo={roleInfo}
          currentPage={currentPage}
          notifications={notifications}
          syscoProducts={syscoProducts}
          syscoProductsLoading={syscoProductsLoading}
          typeItems={typeItems}
          recentDesigns={recentDesigns}
          dispatch={dispatch}
          design={design}
          designs={designs}
          userData={userData}
        />
        {children}
        <Footer />
        <UserSelectorModal
          isOpen={this.state.isUserModalOpen}
          changeVisibility={this.setChangeAccVisibility}
        />
      </div>
    );
  }
}

export default withRouter(App);
